.button-show-new-notes-wrapper {
  display: flex;
  height: 0;
  justify-content: center;
  margin: 0 auto;
  opacity: 1;
  position: sticky;
  top: calc(20px + var(--top-wrapper-navigation-height-mobile, 0px) + var(--piano-banner-navigation-height, 0px));
  transition: opacity 0.25s ease;
  width: max-content;
  z-index: 59;

  @include use-desktop-device {
    top: calc(20px + var(--top-wrapper-premium-board-height, 0px) + var(--top-wrapper-navigation-height, 0px) + var(--top-wrapper-notification-hp-height, 0px) + var(--piano-banner-navigation-height, 0px));
  }

  &:empty { 
    display: none;
  }

  @starting-style {
    opacity: 0;
  }
}

.button-show-new-notes {
  align-items: center;
  appearance: none;
  background-color: var(--palette-accent-urgent);
  border: 0;
  border-radius: 0;
  color: var(--palette-accent-urgent-contra);
  cursor: pointer;
  display: flex;
  font: use-font-secondary("700 14px/16px");
  gap: 0.5ch;
  height: min-content;
  margin: 0 auto;
  padding: 7px 20px;
  text-decoration: none;
  text-transform: uppercase;

  &:focus {
    outline: 1px solid var(--palette-foreground-primary);
  }

  &__number {
    font: use-font-secondary("400 14px/16px");
  }
}
